/* Get Joy home page v14 (canvas v2 build) — tiny module runner + shared helpers for sections/gj-hp-*.liquid.
   Sections mark their root with data-gjhp="<module>" and queue their module inline (this file is deferred):
     <script>(window.GJHP_Q=window.GJHP_Q||[]).push(['name', function (root, GJHP) { … }]);</script>
   Modules run once per root on DOMContentLoaded and again on shopify:section:load (theme editor). */
(function () {
  'use strict';
  if (window.GJHP) return;
  var mods = {}, booted = new WeakSet();

  function run(scope) {
    Array.prototype.forEach.call((scope || document).querySelectorAll('[data-gjhp]'), function (el) {
      var n = el.getAttribute('data-gjhp'), fn = mods[n];
      if (!fn || booted.has(el)) return;
      booted.add(el);
      try { fn(el, window.GJHP); } catch (e) { console.warn('[gjhp] ' + n, e); }
    });
  }
  function register(name, fn) { mods[name] = fn; if (document.readyState !== 'loading') run(document); }

  /* ---------- helpers ---------- */
  var money = function (cents) { return '$' + (Math.round(cents) / 100).toFixed(2); };
  var $ = function (root, sel) { return root.querySelector(sel); };
  var $$ = function (root, sel) { return Array.prototype.slice.call(root.querySelectorAll(sel)); };
  function track(ev, data) { try { (window.dataLayer = window.dataLayer || []).push(Object.assign({ event: ev }, data || {})); } catch (e) {} }
  function config() {
    if (GJHP._cfg) return GJHP._cfg;
    var el = document.getElementById('gj-hp-config');
    try { GJHP._cfg = el ? JSON.parse(el.textContent) : {}; } catch (e) { GJHP._cfg = {}; }
    return GJHP._cfg;
  }

  /* Cart — same behavior as assets/fdr-buybox.js on the live PDP. */
  function openCart() {
    document.dispatchEvent(new CustomEvent('cart:build'));
    document.dispatchEvent(new CustomEvent('cart:refresh'));
    try { if (window.Rebuy && window.Rebuy.Cart && typeof window.Rebuy.Cart.fetchCart === 'function') window.Rebuy.Cart.fetchCart(); } catch (e) {}
    var trig = document.querySelector('.js-drawer-open-cart');
    if (trig) trig.click(); else window.location.href = '/cart';
  }
  // One meal plan per dog: re-adding a plan replaces that dog's existing plan line for this product.
  function replacePlan(handle, dog) {
    dog = String(dog || '').trim();
    return fetch('/cart.js', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); }).then(function (c) {
      var up = {};
      (c.items || []).forEach(function (i) { if (i.handle === handle && i.final_line_price > 0 && String((i.properties || {})._dog_name || '').trim() === dog) up[i.key] = 0; });
      if (!Object.keys(up).length) return null;
      return fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ updates: up }) });
    }).catch(function () { return null; });
  }
  function addItems(items, opts) {
    opts = opts || {};
    var pre = opts.replaceHandle ? replacePlan(opts.replaceHandle, opts.dog) : Promise.resolve();
    return pre.then(function () {
      return fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: items }) });
    }).then(function (r) {
      if (!r.ok) return r.json().then(function (j) { throw new Error(j.description || 'Cart error'); });
      return r.json();
    }).then(function (j) { if (opts.open !== false) openCart(); return j; });
  }
  // Button wrapper: "Adding…" → "✓ Added" → restore.
  function busy(btn, promise, okText) {
    var orig = btn.innerHTML;
    btn.disabled = true; btn.textContent = 'Adding…';
    return promise.then(function (j) {
      btn.disabled = false; btn.textContent = okText || '✓ Added to cart';
      setTimeout(function () { btn.innerHTML = orig; }, 3000);
      return j;
    }, function (err) {
      btn.disabled = false; btn.innerHTML = orig;
      throw err;
    });
  }

  /* Count-up when visible (respects reduced motion; final text = data-to + data-suffix). */
  function countUp(el) {
    var to = parseFloat(el.getAttribute('data-to')) || 0, suf = el.getAttribute('data-suffix') || '', dur = 1200;
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    function fin() { el.textContent = Math.round(to) + suf; }
    if (reduce || !('IntersectionObserver' in window)) return fin();
    el.textContent = '0' + suf;
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) {
        if (!e.isIntersecting) return;
        io.disconnect();
        var t0 = null;
        function step(t) { if (!t0) t0 = t; var p = Math.min(1, (t - t0) / dur); el.textContent = Math.round(to * (1 - Math.pow(1 - p, 3))) + suf; if (p < 1) requestAnimationFrame(step); else fin(); }
        requestAnimationFrame(step);
      });
    }, { threshold: .4 });
    io.observe(el);
  }
  /* Generic behaviors any section can opt into with data attributes. */
  function behaviors(root) {
    // Tabs: [data-gjhp-tabs] > [role=tab][aria-controls] ; panels [role=tabpanel]
    var setH = function (p, h) { if (p.hasAttribute('data-gjhp-mhide')) p.classList.toggle('gjhp-off', h); else p.hidden = h; };
    var isH = function (p) { return p.hasAttribute('data-gjhp-mhide') ? p.classList.contains('gjhp-off') : p.hidden; };
    $$(root, '[data-gjhp-tabs]').forEach(function (tl) {
      var tabs = $$(tl, '[role="tab"]');
      tabs.forEach(function (t) {
        t.addEventListener('click', function () {
          tabs.forEach(function (o) {
            var on = o === t; o.setAttribute('aria-selected', String(on)); o.tabIndex = on ? 0 : -1;
            var p = document.getElementById(o.getAttribute('aria-controls')); if (p) setH(p, !on);
          });
        });
        t.addEventListener('keydown', function (e) {
          var i = tabs.indexOf(t), n = e.key === 'ArrowRight' || e.key === 'ArrowDown' ? 1 : e.key === 'ArrowLeft' || e.key === 'ArrowUp' ? -1 : 0;
          if (!n) return; e.preventDefault(); var nx = tabs[(i + n + tabs.length) % tabs.length]; nx.focus(); nx.click();
        });
      });
    });
    // Accordions: button[aria-expanded][aria-controls]; data-gjhp-acc-group="name" closes siblings
    $$(root, '[data-gjhp-acc]').forEach(function (b) {
      b.addEventListener('click', function () {
        var open = b.getAttribute('aria-expanded') === 'true', grp = b.getAttribute('data-gjhp-acc');
        if (grp) $$(root, '[data-gjhp-acc="' + grp + '"]').forEach(function (o) { if (o !== b) { o.setAttribute('aria-expanded', 'false'); var p0 = document.getElementById(o.getAttribute('aria-controls')); if (p0) p0.hidden = true; } });
        b.setAttribute('aria-expanded', String(!open));
        var p = document.getElementById(b.getAttribute('aria-controls')); if (p) p.hidden = open;
      });
    });
    // Toggles: [data-gjhp-toggle="#id"] flips hidden on the target, swaps label via data-label-open/closed
    $$(root, '[data-gjhp-toggle]').forEach(function (b) {
      b.addEventListener('click', function () {
        var t = root.querySelector(b.getAttribute('data-gjhp-toggle')) || document.querySelector(b.getAttribute('data-gjhp-toggle'));
        if (!t) return; setH(t, !isH(t)); b.setAttribute('aria-expanded', String(!isH(t)));
        var l = isH(t) ? b.getAttribute('data-label-closed') : b.getAttribute('data-label-open'); if (l) b.textContent = l;
      });
    });
    // Rails: [data-gjhp-rail] with sibling [data-gjhp-prev]/[data-gjhp-next] inside the same [data-gjhp-railwrap]
    $$(root, '[data-gjhp-railwrap]').forEach(function (w) {
      var r = $(w, '[data-gjhp-rail]'), pv = $(w, '[data-gjhp-prev]'), nx = $(w, '[data-gjhp-next]');
      if (!r) return;
      var go = function (d) { var c = r.firstElementChild; var step = c ? c.getBoundingClientRect().width + 14 : 300; r.scrollBy({ left: d * step, behavior: 'smooth' }); };
      if (pv) pv.addEventListener('click', function () { go(-1); });
      if (nx) nx.addEventListener('click', function () { go(1); });
    });
    // Inline video: [data-gjhp-video] button with data-src swaps the poster for a playing <video>
    $$(root, '[data-gjhp-video]').forEach(function (b) {
      b.addEventListener('click', function () {
        var box = b.closest('[data-gjhp-vbox]') || b.parentNode, src = b.getAttribute('data-gjhp-video');
        if (!src || box.querySelector('video')) return;
        var v = document.createElement('video'); v.src = src; v.controls = true; v.playsInline = true; v.autoplay = true;
        v.setAttribute('playsinline', ''); v.style.cssText = 'position:absolute;inset:0;width:100%;height:100%;object-fit:cover;background:#000';
        box.appendChild(v); b.hidden = true; v.play && v.play().catch(function () {});
        track('gjhp_video_play', { src: src });
      });
    });
    // Read more: <p class="gjhp-clamp">…</p><button data-gjhp-more data-more="Read more" data-less="Show less">
    $$(root, '[data-gjhp-more]').forEach(function (b) {
      var t = b.previousElementSibling;
      if (!t) return;
      var check = function () { if (!t.classList.contains('is-open')) b.hidden = t.scrollHeight <= t.clientHeight + 2; };
      requestAnimationFrame(check); window.addEventListener('load', check);
      b.addEventListener('click', function () {
        var o = t.classList.toggle('is-open');
        b.setAttribute('aria-expanded', String(o));
        b.textContent = o ? (b.getAttribute('data-less') || 'Show less') : (b.getAttribute('data-more') || 'Read more');
      });
    });
    // Caption pickers: [data-gjhp-cap-group] holds buttons [data-gjhp-cap="<id>"]; the matching caption id shows, others hide
    $$(root, '[data-gjhp-cap-group]').forEach(function (g) {
      var btns = $$(g, '[data-gjhp-cap]');
      var show = function (b) {
        btns.forEach(function (o) {
          var on = o === b; o.setAttribute('aria-pressed', String(on));
          var c = document.getElementById(o.getAttribute('data-gjhp-cap')); if (c) c.hidden = !on;
        });
      };
      btns.forEach(function (b) {
        b.addEventListener('click', function () { show(b); });
        b.addEventListener('mouseenter', function () { if (window.matchMedia('(hover: hover)').matches) show(b); });
        b.addEventListener('focus', function () { show(b); });
      });
    });
    $$(root, '[data-to]').forEach(countUp);
  }
  register('behaviors', behaviors);

  window.GJHP = { register: register, run: run, money: money, $: $, $$: $$, track: track, config: config, openCart: openCart, replacePlan: replacePlan, addItems: addItems, busy: busy, countUp: countUp, behaviors: behaviors };
  // Drain modules queued by sections before this deferred file ran; later pushes register directly.
  var q = window.GJHP_Q || [];
  window.GJHP_Q = { push: function (m) { register(m[0], m[1]); } };
  q.forEach(function (m) { mods[m[0]] = m[1]; });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { run(document); });
  else run(document);
  document.addEventListener('shopify:section:load', function (e) { run(e.target); });
})();
